import { IconImageType } from "@/types/icon";

export const SLUG_IMG_MAP: Record<string, IconImageType> = {
  "/what-is-studycrumb": "file",
  "/how-it-works": "gear",
  "/faq": "faq",
  "/contacts": "email",
  "/dissertation-writing-service": "dissertation-writing-service",
  "/thesis-writing-service": "thesis-writing-service",
  "/term-paper-writing-service": "term-paper-writing-service",
  "/research-paper-writing-service": "research-paper-writing-service",
  "/speech-writing-service": "speech-writing-service",
  "/powerpoint-presentation-writing-service": "presentation-writing-service",
  "/write-my-assignment": "write-my-assignment",
  "/case-study-writing-service": "case-study-writing-service",
  "/capstone-project-writing-service": "capstone-project-writing-service",
  "/book-report-writing-service": "book-report-writing-service",
  "/personal-statement-writing-service": "personal-statement-writing-service",
  "/admission-essay-writing-service": "admission-essay-writing-service",
  "/scholarship-essay-writing-service": "scholarship-essay-writing",
  "/college-essay-writing-service": "college-essay-writing-service",
  "/literature-review-writing-service": "literature-review-writing-service",
  "/write-my-lab-report": "write-my-lab-report",
  "/do-my-homework": "do-my-homework",
  "/buy-essay": "buy-essay",
  "/order-essay": "order-essay",
  "/tools": "all-tools",
  "/tools/assignment-calendar": "assignment-calendar",
  "/tools/words-to-pages-converter": "words-to-pages-converter",
  "/tools/title-page-generator": "title-page-generator",
  "/tools/conclusion-generator": "conclusion-generator",
  "/tools/thesis-statement-generator": "thesis-statement-generator",
  "/tools/essay-title-generator": "essay-title-generator",
  "/tools/alphabetizer": "alphabetizer",
  "/tools/grade-calculator": "grade-calculator",
  "/tools/case-converter": "case-converter",
  "/tools/grammar-checker": "grammar-checker",
  "/tools/plagiarism-checker": "plagiarism-checker",
  "/tools/summarizer": "summarizer",
  "/tools/paraphrasing-tool": "paraphrasing-tool",
  "/tools/word-counter": "word-counter",
  "/tools/readability-checker": "readability-checker",
  "/tools/essay-maker": "essay-maker",
  "/tools/essay-typer": "essay-typer",
  "/tools/free-paper-grader": "paper-grader",
  "/tools/spell-checker": "spell-checker",
  "/tools/coursework-writing-service": "coursework-writing-service",
};
